import React from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup, Button } from '@material-ui/core'

const VirtualFilter = ({ virtual, onChange }) => {
  const handleChange = (state) => {
    if (virtual === state) {
      onChange(undefined)
    } else {
      onChange(state)
    }
  }
  return (
    <ButtonGroup
      disableFocusRipple
      color="primary"
    >
      <Button
        variant={virtual === false ? 'contained' : 'outlined'}
        onClick={() => handleChange(false)}
      >
        In Person
      </Button>
      <Button
        variant={virtual === true ? 'contained' : 'outlined'}
        onClick={() => handleChange(true)}
      >
        Virtual
      </Button>
    </ButtonGroup>
  )
}
VirtualFilter.propTypes = {
  virtual: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}

export default VirtualFilter
